module.exports = __webpack_public_path__ + "img/logo_sankei.f1a2283d.png";